import firebase from 'firebase'

const config = {
    apiKey: "AIzaSyCQeYqiv9Ofc4P6NJHXL5uNzN3MGJs-iVo",
    authDomain: "solapo-9f572.firebaseapp.com",
    databaseURL: "https://solapo-9f572.firebaseio.com",
    projectId: "solapo-9f572",
    storageBucket: "solapo-9f572.appspot.com",
    messagingSenderId: "920216338972"
  };
   var other = firebase.initializeApp(config,"other");

export const ref2 = other.database().ref()
export const auth2 = other.auth()


// WEBPACK FOOTER //
// ./src/config/firebase2.js